import { forwardRef } from "@chakra-ui/react";

export const chakraRef = forwardRef;

export default chakraRef;
